import { queryDispatchUser } from '@api/announcement';
import { Form, FormInstance, Input, Radio } from 'antd';
import { List } from 'antd-mobile';
import type { CSSProperties } from 'react';
import { useEffect, useState } from 'react';
import { AutoSizer, List as VirtualizedList } from 'react-virtualized';
import { useImmer } from 'use-immer';
import './index.scss';
const { TextArea } = Input;
interface UserProps {
  form: FormInstance;
  isAdmin: boolean;
  open?: boolean;
}
export const useTransferForm = ({ form, isAdmin, open }: UserProps) => {
  const [userList, setUserList] = useImmer([]);
  const [total, setTotal] = useImmer(0);
  const [currentUserId, setCurrentUserId] = useState('');
  const getDispatchUser = async () => {
    const res: any = await queryDispatchUser({
      pageNumber: 1,
      pageSize: 999,
      type: 'sector'
    });
    setTotal(res?.users?.total || 0);
    setUserList(res?.users?.records);
  };

  const handleClickRadio = (item: any) => {
    setCurrentUserId(item.userId);
    form.setFieldsValue({
      frontEndRemarks: {
        dispatchUserId: item.userId,
        dispatchUserName: item.realName
      }
    });
  };

  useEffect(() => {
    if (!open) setCurrentUserId('');
  }, [open]);

  useEffect(() => {
    getDispatchUser();
  }, []);

  const ListItemWithCheckbox = ({ item, key, style }: any) => {
    return (
      <List.Item
        extra={
          <div onClick={() => handleClickRadio(item)}>
            <Radio
              checked={currentUserId === item?.userId}
              className="sector_radio"
            />
          </div>
        }
        style={style}
        arrow={false}
        key={key}
      >
        <div>
          <div className="pc-footer-transferTip-name">{item?.realName}</div>
          <div className="pc-footer-transferTip-email">{item?.email}</div>
        </div>
      </List.Item>
    );
  };

  const rowRenderer = ({
    index,
    key,
    style
  }: {
    index: number;
    key?: string;
    style: CSSProperties;
  }) => {
    return (
      <ListItemWithCheckbox style={style} key={key} item={userList[index]} />
    );
  };

  const transferForm = (
    <div className="pc-footer-repeat">
      <div className="pc-footer-transferTip">
        {isAdmin
          ? null
          : '如果公告中的项目由其他同事负责，请转给相关同事。如果不知道负责人，请发邮件给digital.microscopy.cn@zeiss.com'}
      </div>
      <Form.Item name={'frontEndRemarks'}>
        <List>
          <AutoSizer disableHeight>
            {({ width }: { width: number; height: number }) => (
              <VirtualizedList
                rowCount={total}
                rowRenderer={rowRenderer}
                width={width}
                height={total < 10 ? 60 * total : 400}
                rowHeight={60}
                overscanRowCount={10}
              />
            )}
          </AutoSizer>
          {/* {[
            ...userList,
            { userId: 111111, realName: '4323', email: '423423423' }
          ].map((item, index) => (
            <ListItemWithCheckbox key={index} item={item} />
          ))} */}
        </List>
      </Form.Item>
      <Form.Item
        label={'备注：'}
        name={'recordRemark'}
        // rules={[{ required: true }]}
      >
        <TextArea placeholder="输入备注内容" rows={3} />
      </Form.Item>
    </div>
  );
  return {
    transferForm
  };
};
